import { type PropsWithChildren } from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

type IPresetGridProps = PropsWithChildren<{
  columns?: 2 | 3
  className?: string
}>

export const PresetGrid = ({ children, columns = 3, className }: IPresetGridProps) => (
  <div
    className={classNames(styles.grid, className, {
      [styles.gridColumns2]: columns === 2,
    })}
  >
    {children}
  </div>
)
